module.exports = __webpack_public_path__ + "static/media/brand-imagery-graph-bg.df107bc4.svg";